const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/components/Buttons/styles.ts';
import { css } from '@emotion/css';
import { useTheme } from '@mui/material/styles';
import { useMemo } from 'react';

export function useCSSClasses() {
    const theme = useTheme();
    return useMemo(
        () => ({
            btnRoot: css`
                text-transform: inherit;
            `,
        }),
        [theme]
    );
}
